module.exports = __webpack_public_path__ + "fonts/TiemposFine-RegularItalic.woff";